import { isAfter, isToday } from 'date-fns';
import { isValidPhoneNumber } from 'libphonenumber-js/max';
import * as Yup from 'yup';
import { JobTitle } from '../../../domain/types';
import { COUNTRY } from '../../../constants';

const hireApplicantValidationSchema = Yup.object({
  workName: Yup
    .string()
    .trim()
    .required('Il campo è obbligatorio'),
  workSurname: Yup
    .string()
    .trim()
    .required('Il campo è obbligatorio'),
  personalEmail: Yup
    .string()
    .trim()
    .required('Il campo è obbligatorio')
    .email('Inserisci un indirizzo email valido'),
  workEmail: Yup
    .string()
    .trim()
    .email('Inserisci un indirizzo email valido'),
  pecEmail: Yup
    .string()
    .trim()
    .email('Inserisci un indirizzo PEC valido'),
  personalMobile: Yup
    .string()
    .trim()
    .required('Il campo è obbligatorio')
    .test(
      'validPhoneNumber',
      'Inserisci un numero di telefono valido',
      (value: string | undefined) => !value || isValidPhoneNumber(value, COUNTRY),
    ),
  workMobile: Yup
    .string()
    .trim()
    .test(
      'validPhoneNumber',
      'Inserisci un numero di telefono valido',
      (value: string | undefined) => !value || isValidPhoneNumber(value, COUNTRY),
    ),
  fiscalCode: Yup
    .string()
    .trim()
    .length(16, 'Il codice fiscale deve essere composto da 16 caratteri.'),
  role: Yup
    .string()
    .oneOf(Object.values(JobTitle))
    .required('Il ruolo è obbligatorio'),
  startDate: Yup
    .date()
    .test(
      'isDateInTheFuture',
      'La data di inizio deve essere nel futuro',
      (value) => value !== undefined && (isToday(value) || isAfter(value, new Date())),
    )
    .required('La data di inizio è obbligatoria'),
  hasLicense: Yup
    .boolean()
    .required('Il campo è obbligatorio')
    .test(
      'validHasLicense',
      'Inserisci un valore valido',
      (value, ctx) => {
        const { role, needsSupervisor } = ctx.parent;

        switch (role) {
          case JobTitle.AGENTE: return !!value;
          case JobTitle.AREA_MANAGER: return !!value;
          case JobTitle.CONSULENTE: return !value;
          case JobTitle.BROKER:
          case JobTitle.EXECUTIVE:
          case JobTitle.TEAM_LEADER: return !needsSupervisor ? !!value : true;
          default: return true;
        }
      },
    ),
  needsSupervisor: Yup
    .boolean()
    .required('Il campo è obbligatorio')
    .test(
      'validNeedsSupervisor',
      'Inserisci un valore valido',
      (value, ctx) => {
        const { role, hasLicense } = ctx.parent;

        switch (role) {
          case JobTitle.AREA_MANAGER: return !value;
          case JobTitle.CONSULENTE: return !!value;
          case JobTitle.BROKER:
          case JobTitle.EXECUTIVE:
          case JobTitle.TEAM_LEADER: return !hasLicense ? !!value : true;
          default: return true;
        }
      },
    ),
});

export default hireApplicantValidationSchema;
